<template>
  <button
    class="base-button tw-font-[400] tw-border"
    :class="[sizeClass, colorClass, disabledClass]"
    v-on="$listeners"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "md",
      validator: (value) => ["md", "lg"].includes(value),
    },
    color: {
      type: String,
      required: true,
      validator: (value) =>
        ["primary", "secondary", "posey-green"].includes(value),
    },
    outline: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sizeClass() {
      switch (this.size) {
        case "md":
          return `
            tw-min-w-[120px]
            tw-text-[14px]
            tw-py-[12px]
            tw-px-[32px]
            tw-leading-[20px]
            tw-letter-spacing-[-0.25px]
          `;

        case "lg":
          return `
            tw-min-w-[160px]
            tw-text-[16px]
            tw-py-[16px]
            tw-px-[48px]
            tw-leading-[24px]
            tw-letter-spacing-[-0.5px]
          `;

        default:
          return "";
      }
    },

    colorClass() {
      switch (this.color) {
        case "primary":
          return this.outline
            ? `tw-bg-transparent tw-border-primary tw-text-primary`
            : `tw-bg-primary tw-border-primary tw-text-white`;

        case "secondary": {
          if (this.outline) {
            return "tw-bg-transparent tw-border-secondary tw-text-secondary hover:tw-bg-secondary/10";
          }

          if (this.text) {
            return "tw-bg-transparent tw-border-transparent tw-text-secondary hover:tw-bg-secondary/10";
          }

          return `tw-bg-secondary/90 hover:tw-bg-secondary  tw-border-secondary tw-text-white`;
        }

        case "info":
          return this.outline
            ? `tw-border-info tw-bg-transparent tw-text-info`
            : `tw-bg-info tw-text-black`;

        case "secondary-mischka":
          return this.outline
            ? `tw-border-secondary-mischka tw-bg-transparent tw-text-secondary-mischka`
            : `tw-border-secondary-mischka tw-bg-secondary-mischka tw-text-black`;

        case "posey-green":
          return this.outline
            ? `tw-border-posey-green tw-bg-transparent tw-text-posey-green`
            : `tw-bg-posey-green tw-text-white`;

        case "gray":
          return this.outline
            ? `tw-border-gray tw-bg-transparent tw-text-gray`
            : `tw-bg-gray tw-text-black`;

        default:
          return "";
      }
    },

    disabledClass() {
      return this.$attrs.disabled
        ? "tw-opacity-[0.80] tw-cursor-not-allowed"
        : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.base-button {
  border: none;
  border-style: solid;
  box-sizing: border-box;
  display: inline-block; // Buttons are inline-block by default
  text-align: center; // Center the text
  cursor: pointer; // Show a pointer cursor when hovering over the button
  user-select: none; // Prevent the user from selecting the button text
  border-radius: 28px;
  font-style: normal;
  transition: background-color 0.2s ease-in-out;
}
</style>
